/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/button-has-type */
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon, { IconType, IconSize } from '../icon/icon';
import { ButtonSize } from '../button/button';
import Modal, { ModalSize } from '../../molecules/modal/modal';
import FormInputText from '../../molecules/formInputText/formInputText';
import FormCheckbox from '../../molecules/formCheckbox/formCheckbox';
import Button, { ButtonTheme, ButtonType } from '../../atoms/button/button';
import FormInputTypes from '../formEnums/formInputTypes';
import { httpGet, httpPost } from '../../../store/externalCalls/httpCalls';
import { useLocation, useNavigate } from 'react-router-dom';
import Toaste from '../toast/toaste';
import FormInputTime from '../../molecules/formInputTime/formInputTime';
import Table from '../../molecules/table/table';
import { TablePagination } from '../../molecules/table';
import TableSectionv2 from '../../organisms/tableSection/tableSectionv2';
import { appendParamsToURL, composeURL, getPartialPath } from '../../../utils/urlTools';
import { mapPagination } from '../../../store/externalCalls/api/maps';
import FormSelect from '../../molecules/formSelect/formSelect';
import FormExternalResource from '../../molecules/formExternalResource/formExternalResource';
import ListTableComponent from '../../organisms/listTableComponent/listTableComponent';
import FormInputObj from '../../molecules/formInputObj/formInputObj';
import FormDatePicker from '../../molecules/formDatePicker/formDatePicker';
import FormRelationship from '../../organisms/formRelationship/formRelationship';
import swal from 'sweetalert';
import WebsocketLog from '../../organisms/WebsocketLog/websocketLog';
import ExternalLink from '../externalLink/externalLink';
import FormLink from '../../molecules/formLink/formLink';
import { is } from 'date-fns/locale';
import FormTextEditor from '../../molecules/formTextEditor/formTextEditor';
export const ButtonkSize = {
  BLOCK: 'block',
  LARGE: 'lg',
  SMALL: 'sm',
  '': '',
};

/**
 * Basic link component, it’s designed to edit the href attribute
 */
const ButtonPopup = (props) => {
  const {
    theme, size, children, className, icon, iconColor, iconSize, buttonText, disabled, enabledWhen, dataSet,
    redirectUrl, actionUrl, refreshIfOk, openUrl, value, formConfig, id, isEditId, onUpdateValues, reconfirmText, sessionParams
  } = props;
  const location = useLocation();
  const match = {
    url: location.pathname,
  };
  const classProps = classNames(
    'btn',
    `btn-${theme}`,
    `btn-${size}`,
    className,
  );
  const [showModal, setShowModal] = useState(false);
  const [popupErrors, setPopupErrors] = useState({});
  const [fieldValue, setFieldValue] = useState({});
  const navigate = useNavigate();
  useEffect(() => {
    let newValues = {};
    for (let f in formConfig.fields) {
      if (formConfig.fields[f].defaultValue) {
        newValues = { ...newValues, ...{ [formConfig.fields[f].attributeName]: formConfig.fields[f].defaultValue } };
      }
    }
    setFieldValue({ ...fieldValue, ...newValues });
  }, [formConfig, disabled]);

  const actionOK = () => {
    let url;
    if (isEditId) {
      let location = window.location.pathname;
      let locationArr = location.split("/");
      url = actionUrl + "/" + locationArr[locationArr.length - 1];
    } else {
      url = actionUrl;
    }
    let params = fieldValue || {};
    params.id = value;
    httpPost(url, params).then((res) => {
      if (res.status == true) {
        setShowModal(false);
        if (redirectUrl) {
          const basePath = location.pathname.replace(new RegExp(`/${redirectUrl}$`), '');
          navigate(`${basePath}/${redirectUrl}`, {
            replace: true, state: {
              from: location.pathname,
            },
          });
        } else if (refreshIfOk) {
          window.location.reload();
        }
        else {
          onUpdateValues(res.value);
        }
      } else {
        setPopupErrors(res.errors);
        setTimeout(() => {
          setPopupErrors({});
        }, 2000);
      }
    }).catch(error => {
      setPopupErrors(error.errors);
      setTimeout(() => {
        setPopupErrors({});
      }, 2000);
    });
  }
  const handlePopupOK = () => {
    if (reconfirmText) {
      swal({
        title: 'Are you sure?',
        text: reconfirmText,
        buttons: true
      }).then((ok) => {
        if (ok) {
          actionOK();
        }
      });
    } else
      actionOK();

  }
  const handlerOnClick = () => {
    if (disabled) {
      return;
    }

    if (openUrl) {
      let url = openUrl + "?id=" + value;
      httpGet(url).then((res) => {
        setFieldValue(res);
        setShowModal(true);
      }).catch(error => {
        setFieldValue(null);
      });
    } else {
      setShowModal(true);
    }


  }
  const handleOnClosePopup = () => {
    setShowModal(false);
  }
  const handlerOnChange = (e, attributeName, type) => {
    let value = e.target.value;
    if (type == "check") {
      value = e.target.checked;
    }
    setFieldValue({ ...fieldValue, ...{ [attributeName]: value } });
  }

  const handlerChangeFromWebsocket = (data, elementsFromWebsocket) => {
    if (elementsFromWebsocket) {
      const valuesToAdd = [];
      elementsFromWebsocket.map((elementFromWebsocket) => {
        valuesToAdd[elementFromWebsocket] = data[elementFromWebsocket];
      });
      setFieldValue({ ...fieldValue, ...valuesToAdd });
    }
  }

  const handlerFormButton = (newDataObject, attributeName) => {
    setFieldValue({ ...fieldValue, ...{ [attributeName]: newDataObject.id } });
  };
  const handlerChangePage = (page) => {
    httpGet(page).then((res) => {
      setFieldValue(res);
      setShowModal(true);
    }).catch(error => {
      setFieldValue(null);
    });
  }
  const handleFilter = (filters) => {
    let url = openUrl + "?id=" + value + "&";
    let pageFilter = appendParamsToURL(url, filters);
    httpGet(pageFilter).then((res) => {
      setFieldValue(res);
      setShowModal(true);
    }).catch(error => {
      setFieldValue(null);
    });
  }

  const handleSort = (sort) => {
    const { attributeName, sortDown } = sort;
    const orderList = sortDown ? 'asc' : 'desc';
    const obj = {
      sort_by: attributeName,
      order: orderList,
    };
    let url = openUrl + "?id=" + value + "&";
    const searchURL = appendParamsToURL(url, obj);
    httpGet(searchURL).then((res) => {
      setFieldValue(res);
      setShowModal(true);
    }).catch(error => {
      setFieldValue(null);
    });
  }

  const isVisibleWhen = (field, value) => {
    let isVisible = true;
    if (field.visibleWhen) {
      isVisible = value[field.visibleWhen.field] == field.visibleWhen.value;
    }
    return isVisible;
  };

  const handlerUpdate = () => {
    console.log("update");
  }
  const handlerChangeAndRefresh = () => {
    console.log("TBD");
  }
  return (
    <div data-component="button-popup">
      {showModal && <Modal
        title={formConfig ? formConfig.title : ''}
        onClose={handleOnClosePopup}
        size={ModalSize.XLARGE}
      >
        <div>

          {popupErrors && Object.keys(popupErrors).length > 0
            && (
              <Toaste type="error" mode="normal" data={popupErrors} />
            )}

          {formConfig && <div>{formConfig.description}
            {formConfig.fields.map((field, i) => {
              let out = <></>;
              if (field.default && !fieldValue[field.attributeName]) {
                fieldValue[field.attributeName] = field.default;
              }
              if (field.enabledWhen) {
                let f = field.enabledWhen.field;
                let values = field.enabledWhen.values;
                if (values) {
                  if (values.includes(fieldValue[f]))
                    field.disabled = false;
                  else
                    field.disabled = true;
                }
                let notValues = field.enabledWhen.notValues;
                if (notValues) {
                  if (notValues.includes(fieldValue[f])) {
                    field.disabled = true;
                  } else {
                    field.disabled = false;
                  }
                }
              }
              if (isVisibleWhen(field, fieldValue)) {
                switch (field.type) {
                  case FormInputTypes.SEPARATOR:
                    out = (<hr />);
                    break;
                  case FormInputTypes.CHECKBOX:
                    out = (
                      <FormCheckbox
                        key={formConfig.attributeName + i}
                        label={field.label}
                        id={(formConfig.attributeName ? formConfig.attributeName + "-" : "") + field.attributeName}
                        helpText={field.helpText}
                        checked={(fieldValue ? fieldValue[field.attributeName] : false)}
                        onChange={(event) => handlerOnChange(event, field.attributeName, "check")}
                        disabled={(field.disabled ? field.disabled : false)}
                        confirmPopup={(field.confirmPopup ? field.confirmPopup : false)}
                        confirmText={(field.confirmText ? field.confirmText : "")}
                        hidden={field?.hidden ?? false}
                      />
                    );
                    break;

                  case FormInputTypes.RELATIONSHIP:
                    out = (
                      <FormRelationship
                        id={`${field.attributeName}-${field.attributeName}`}
                        isForm
                        key={field.attributeName + i}
                        label={field.label}
                        helpText={field.helpText}
                        configFile={field.configFile}
                        value={fieldValue[field.attributeName] ? fieldValue[field.attributeName] : []}
                        // value={formGroupValue && formGroupValue[field.attributeName]?formGroupValue[field.attributeName]:null}
                        maxElements={field.maxElements}
                        onSelectUrl={field.onSelectUrl}
                        disabled={(field.disabled ? field.disabled : false)}
                        onChange={(data) => handlerOnChange(data, field.attributeName)}
                      />
                    );
                    break;
                  case FormInputTypes.TEXT:
                    out = field?.hidden ? null : <div>{field.default}</div>;
                    break;
                  case FormInputTypes.TEXT_INPUT.TEXT:
                  case FormInputTypes.TEXT_INPUT.NUMBER:
                    out = (
                      <FormInputText
                        id={`${formConfig.attributeName}-${field.attributeName}`}
                        key={field.attributeName + i}
                        name={field.label}
                        placeholder={field.placeholder}
                        helpText={field.helpText}
                        type={field.type}
                        // value={value ? value[field.attributeName] : ''}
                        value={(fieldValue ? fieldValue[field.attributeName] : '')}
                        label={field.label}
                        multiple={field.multiple}
                        configFile={field.fromCatalog}
                        onChange={(event) => handlerOnChange(event, field.attributeName)}
                        defaultValue={field.default === undefined ? '' : field.default}
                        hidden={field.hidden}
                        multiline={field.multiline}
                      />
                    )
                    break;
                  case FormInputTypes.TEXT_INPUT.INPUT_TIME:
                    out = (
                      <FormInputTime
                        id={`${formConfig.attributeName}-${field.attributeName}`}
                        key={field.attributeName + i}
                        name={field.label}
                        placeholder={field.placeholder}
                        helpText={field.helpText}
                        separator={field.separator}
                        useSeconds={field.useSeconds}
                        // value={value ? value[field.attributeName] : ''}
                        value={(fieldValue ? fieldValue[field.attributeName] : '')}
                        label={field.label}
                        onChange={(event) => handlerOnChange(event, field.attributeName)}
                        defaultValue={field.default === undefined ? '' : field.default}
                      />
                    )
                    break;
                  case FormInputTypes.SELECT:
                    out = (
                      <>
                        <FormSelect
                          id={(formConfig.attributeName ? formConfig.attributeName + "-" : "") + field.attributeName}
                          key={field.attributeName + i}
                          label={field.label}
                          value={(value && value[field.attributeName]) ? value[field.attributeName] : ''}
                          emptyValue={field.emptyValue}
                          allValue={field.allValue}
                          asyncSelect={field.asyncSelect}
                          placeholder={field.placeholder}
                          parentField={(field.parentField ? field.parentField : null)}
                          refreshData={(field.refreshData ? field.refreshData : null)}
                          url={field.url}
                          validateUrl={field.validateUrl}
                          filter={field.filter}
                          helpText={field.helpText}
                          options={field.options}
                          multiple={field.multiple}
                          fieldValue={field.fieldValue}
                          fieldName={field.fieldName}
                          pageId={field.pageId}
                          onChange={(event) => handlerOnChange(event, field.attributeName)}
                          disabled={(field.disabled ? field.disabled : false)}
                          session={(field.session ? field.session : null)}
                          sessionParams={sessionParams ? sessionParams : []}
                        /></>
                    );
                    break;
                  case FormInputTypes.DOWNLOADABLE:
                    out = (
                      <FormExternalResource
                        id={(formConfig.attributeName ? formConfig.attributeName + "-" : "") + field.attributeName}
                        type={field.type}
                        key={field.attributeName + i}
                        label={field.label}
                        helpText={field.helpText}
                        fileType={field.fileType}
                        hasSelect={field.hasSelect}
                        value={value ? value[field.attributeName] : ''}
                        onChange={(data) => handlerFormButton(data, field.attributeName)}
                        aspectRatio={field.aspectRatio}
                        imageWidth={field.imageWidth}
                        imageHeight={field.imageHeight}
                        canUpload={field.canUpload}
                        canUpdate={field.canUpdate}
                        canDelete={field.canDelete}
                        size={field.size}

                      />
                    );
                    break;
                  case FormInputTypes.TABLE:
                    let tableValues = mapPagination(fieldValue[field.attributeName]);
                    out = (
                      <TableSectionv2
                        configFile={field.configFile}
                        urlParams={field.configFile}
                        valuesPaginated={tableValues}
                        customEditUrl={field.configFile.customEditUrl}
                        id={id}
                        onChangePage={(e) => handlerChangePage(e, tableValues)}
                        onSearch={(e) => handleFilter(e)}
                        onSort={(e) => handleSort(e)}
                        // onClickCreate={handlerCreate}
                        initDataSelected={[]}
                      />);
                    break;
                  case FormInputTypes.TABLECOMPONENT:
                    let tableValuesC = mapPagination(fieldValue[field.attributeName]);
                    out = (
                      <ListTableComponent
                        classId={`${field.attributeName}-${field.attributeName}`}
                        key={field.attributeName + i}
                        configFile={field.configFile}
                        tableName={field.attributeName}
                        mode={field.mode}
                        onChange={(event) => handlerOnChange({ target: { value: event } }, field.attributeName)}
                        onChangeAndRefresh={handlerChangeAndRefresh}
                        value={tableValuesC}
                        match={match}
                      />
                    );
                    break;
                  case FormInputTypes.TEXT_INPUT.OBJECT:
                    out = (
                      <FormInputObj
                        id={`${field.attributeName}-${field.attributeName}`}
                        key={field.attributeName + i}
                        name={field.label}
                        placeholder={field.placeholder}
                        helpText={field.helpText}
                        type={"text"}
                        childFields={field.childFields}
                        mainField={field.mainField}
                        // value={value ? value[field.attributeName] : ''}
                        // value={(fieldValue?fieldValue[field.attributeName]:(formGroupValue[field.attributeName]!= undefined?formGroupValue[field.attributeName]:''))}
                        value={value && value[field.attributeName] ? value[field.attributeName] : ''}

                        label={field.label}
                        configFile={field.fromCatalog}
                        relatedConfigTable={field.fromConfigTable}
                        onChange={(event) => handlerOnChange(event, field.attributeName)}
                        // errorText={errorState[field.attributeName] === undefined
                        //   ? '' : errorState[field.attributeName][0]}
                        defaultValue={field.default === undefined ? '' : field.default}
                        disabled={(field.disabled ? field.disabled : false)}
                        returnValue={(field.returnValue ? field.returnValue : null)}
                        inputEnabled={(field.inputEnabled ? field.inputEnabled : false)}
                        selectedValue={value}
                      />
                    );
                    break;
                  case FormInputTypes.DATE:
                  case FormInputTypes.DATE_TIME:

                    out = (
                      <FormDatePicker
                        id={(field.attributeName ? field.attributeName + "-" : "") + field.attributeName}
                        key={field.attributeName + i}
                        label={field.label}
                        // value={value[field.attributeName] ? value[field.attributeName] : field.default}
                        value={(fieldValue && fieldValue[field.attributeName] ? fieldValue[field.attributeName] : field.default)}
                        disabled={(field.disabled ? field.disabled : false)}
                        onChange={(data) => handlerOnChange(data, field.attributeName)}
                        helpText={field.helpText}
                      />
                    );
                    break;
                  case FormInputTypes.DOWNLOADABLE:
                  case FormInputTypes.BACKGROUND:
                    out = (
                      <>
                        <FormExternalResource
                          id={`${field.attributeName}-${field.attributeName}`}
                          type={field.type}
                          key={field.attributeName + i}
                          label={field.label}
                          helpText={field.helpText}
                          fileType={field.fileType}
                          hasSelect={field.hasSelect}
                          value={fieldValue ? fieldValue[field.attributeName] : ''}
                          // value={(formGroupValue && formGroupValue[field.attributeName]?formGroupValue[field.attributeName]:'')}
                          onChange={(data) => handlerFormButton(data, field.attributeName)}
                          aspectRatio={field.aspectRatio}
                          imageWidth={field.imageWidth}
                          imageHeight={field.imageHeight}
                          canUpload={field.canUpload}
                          canUpdate={field.canUpdate}
                          canDelete={field.canDelete}
                          disabled={field.disabled}
                          size={field.size}

                        /></>
                    );
                    break;
                  case FormInputTypes.WEBSOCKET_LOG:
                    out = (
                      <WebsocketLog
                        id={`${field.attributeName}-${field.attributeName}`}
                        key={field.attributeName + i}
                        title=""
                        eventChanel={field.websocketChannel}
                        websocketParam={fieldValue[field.websocketParam]}
                        initialValues={fieldValue ? fieldValue[field.attributeName] : ''}
                        onMessageReceived={(data) => handlerChangeFromWebsocket(data, field.elementsFromWebsocket)}
                      />
                    );
                    break;
                  case FormInputTypes.LINK:
                    out = (<FormLink
                      className="p-3"
                      label={field.label}
                      id={`${field.attributeName}-${field.attributeName}`}
                      key={field.attributeName + i}
                      icon={field.icon}
                      to={fieldValue && fieldValue[field.attributeName] ? fieldValue[field.attributeName] : ''}
                      helpText={field.helpText}
                      hasClick={field.hasClick}
                      iconSize={IconSize.DOUBLE}
                    />);
                    break;
                  case FormInputTypes.TEXT_EDITOR:
                    out = (
                      <FormTextEditor
                        id={`${field.attributeName}-${field.attributeName}`}
                        key={field.attributeName + i}
                        toolbar={field.toolbar}
                        name={field.label}
                        label={field.label}
                        // value={value ? value[field.attributeName] : ''}
                        value={(fieldValue ? fieldValue[field.attributeName] : null)}

                        helpText={field.helpText}
                        // validation={errorState[field.attributeName] === undefined
                        //   ? FormValidation.PENDING : FormValidation.ERROR}
                        onChange={(data) => handlerOnChange(data, field.attributeName)}

                      />
                    );
                    break;
                }
              }


              return (<div key={field.attributeName + i} className={field.className ? field.className : "col-sm-12"}>{out}</div>);
            })}

          </div>}
        </div>
        <div style={{ width: '100%' }}>
          <div style={{ float: 'left' }}>
            <Button
              id={`button-cancel`}
              type={ButtonType.BUTTON}
              onClick={() => handleOnClosePopup()}
              theme={ButtonTheme.SECONDARY}
            >
              Cancel
            </Button>
          </div>
          {actionUrl && <div style={{ float: 'right' }}>
            <Button
              id={`button-ok`}
              theme={ButtonTheme.PRIMARY}
              onClick={handlePopupOK}
            >
              Ok
            </Button>
          </div>}
        </div>
      </Modal>}
      {!buttonText && <a
        id={id}
        className={theme !== '' ? classProps : ''}
        onClick={handlerOnClick}
        disabled={disabled}
      >
        {icon !== ''
          && (
            <Icon
              icon={icon}
              iconSize={iconSize}
              iconColor={iconColor}
              disabled={disabled}
            />
          )}
        {children}
      </a>}
      {buttonText && <Button
        id={id ? id : `button-ok`}
        theme={theme ? theme : ButtonTheme.PRIMARY}
        onClick={handlerOnClick}
      >
        {buttonText}
      </Button>}
    </div>
  );
};

ButtonPopup.propTypes = {
  /**
   * Link background color
   */
  theme: PropTypes.oneOf(Object.values(ButtonTheme)),
  /**
   * Link general size
   */
  size: PropTypes.oneOf(Object.values(ButtonSize)),
  /**
   * Content to put inside the link component
   */
  children: PropTypes.node,
  /**
   * CSS classes to customize link
   */
  className: PropTypes.string,
  /**
   * To select a icon inside the link
   */
  icon: PropTypes.oneOf(Object.values(IconType)),
  /**
   * Icon color inside the link
   */
  iconColor: PropTypes.string,
  /**
   * Icon size inside the link
   */
  iconSize: PropTypes.oneOf(Object.values(IconSize)),
  /**
   * To disable the link functionality
   */
  disabled: PropTypes.bool,
  /**
   * Link reference
   */
  to: PropTypes.string,
};

ButtonPopup.defaultProps = {
  theme: '',
  size: ButtonSize.SMALL,
  children: null,
  className: '',
  icon: '',
  iconColor: '',
  iconSize: IconSize.SMALL,
  disabled: false,
};

export default ButtonPopup;
